import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./Home.css"; // your custom CSS
import { useNavigate } from "react-router-dom";

//Logos
import maxTechLogo from "../pictures/MaxTechLogo.svg";
import skyslopeLogo from "../pictures/SkyslopeLogo.png";
import brightMLSLogo from "../pictures/brightMLSLogo.png";
import urlshortLogo from "../pictures/UrlShortner.png";
import showingTimeLogo from "../pictures/showingTimeLogo.png";
import maxCenterLogo from "../pictures/maxCenterLogo.png";
import maxShop from "../pictures/maxShop.png";
import backOfficeLogo from "../pictures/backOfficeLogo.png";
import outlookLogo from "../pictures/outlookLogo.png";
import palsLogo from "../pictures/palsLogo.png";
import pmgLogo from "../pictures/deltaPMGLogo.png";
import rprLogo from "../pictures/rpr.png";
import dueDLogo from "../pictures/dueD.png";
import deedSearchLogo from "../pictures/deedSearch.png";
import utilityInfo from "../pictures/Utility Info by County.png";
import hoaLogo from "../pictures/hoaLogo.png";
import mLogo from "../pictures/marketingLogo.png";
import eLogo from "../pictures/escrowLogo.png";
import tLogo from "../pictures/title.png";
import calendarLogo from "../pictures/calendarLogo.png";

import comingSoon from "../pictures/comingSoon.png";

const ResponsiveGridLayout = WidthProvider(Responsive);

//Buttons
const widgets = [
  { key: "maxtech", title: "MaxTech", url: "https://remax.okta.com/app/remaxprod_engagere_1/exke8v4hctzGLGn6V0x7/sso/saml?redirect=1&relaystate=http%3a%2f%2fsecure.engageremarketing.com%2fexternalsso%2frllogin.aspx%3fdestination%3dmaxtech", icon: maxTechLogo },
  { key: "skyslope", title: "Skyslope", url: "https://app.skyslope.com/LoginIntegrated.aspx", icon: skyslopeLogo },
  { key: "Bright MLS", title: "Bright MLS", url: "https://login.brightmls.com/login", icon: brightMLSLogo },
  { key: "urlshort", title: "URL Shortener", url: "https://www.remax.net/shortener", icon: urlshortLogo },
  { key: "showingTime", title: "Showing Time", url: "https://login.showingtime.com/ui/login", icon: showingTimeLogo },
  { key: "maxCenter", title: "Max Center", url: "https://www.remax.net/home", icon: maxCenterLogo },
  { key: "maxShop", title: "RE/MAX Marketplace", url: "https://shop.remax.com", icon: maxShop },
  { key: "backOffice", title: "BoldTrail BackOffice", url: "https://my.brokermint.com/users/sign_in#/", icon: backOfficeLogo },
  { key: "outlook", title: "Outlook", url: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=9199bf20-a13f-4107-85dc-02114787ef48&scope=https%3A%2F%2Foutlook.office.com%2F.default%20openid%20profile%20offline_access&redirect_uri=https%3A%2F%2Foutlook.live.com%2Fmail%2F", icon: outlookLogo },
  { key: "pals", title: "PALS", url: "https://www.pals.pa.gov/#!/page/default", icon: palsLogo },
  { key: "deltaPMG", title: "Delta Property Management Group", url: "https://www.deltapmg.com", icon: pmgLogo },
  { key: "deltaEscrow", title: "RE/MAX Delta Group Escrow", url: "https://www.remaxescrow.com", icon: eLogo },
  { key: "RPR", title: "RPR", url: "https://auth.narrpr.com/auth/sign-in", icon: rprLogo },
  { key: "countyDeed", title: "County Deed Viewer", url: "/deed", icon: deedSearchLogo },
  { key: "trainingCalendar", title: "Training Calendar", url: "/training-calendar", icon: calendarLogo },
  { key: "utilityInfo", title: "Utility Info By Munincipality", url: "/utility", icon: utilityInfo },
  { key: "deltaMarketing", title: "Delta Group Marketing", url: "/", icon: comingSoon }, //coming soon
  { key: "hoaCondo", title: "HOA & Condo", url: "/", icon: comingSoon }, //coming soon
  { key: "titleInsurance", title: "Title Insurance Guide", url: "/title", icon: tLogo },
];

// Location of buttons: x, y = position; w = width; h = height
const layout = [
  { i: "maxtech", x: 0, y: 0, w: 1, h: 1 },
  { i: "skyslope", x: 1, y: 0, w: 2, h: 1 },
  { i: "Bright MLS", x: 2, y: 1, w: 1, h: 1 },
  { i: "urlshort", x: 0, y: 4, w: 1, h: 1 },
  { i: "showingTime", x: 2, y: 2, w: 1, h: 1 },
  { i: "maxCenter", x: 2, y: 3, w: 1, h: 1 },
  { i: "maxShop", x: 2, y: 4, w: 1, h: 1 },
  { i: "backOffice", x: 1, y: 4, w: 1, h: 2 },
  { i: "outlook", x: 0, y: 5, w: 1, h: 1 },
  { i: "pals", x: 1, y: 6, w: 1, h: 1 },
  { i: "deltaPMG", x: 2, y: 5, w: 1, h: 1 },
  { i: "countyDeed", x: 1, y: 2, w: 1, h: 1 },
  { i: "dueDiligence", x: 0, y: 6, w: 1, h: 1 },
  { i: "utilityInfo", x: 0, y: 3, w: 1, h: 1 },
  { i: "trainingCalendar", x: 1, y: 1, w: 1, h: 1 },
  { i: "hoaCondo", x: 2, y: 6, w: 1, h: 1 },
  { i: "RPR", x: 0, y: 1, w: 1, h: 2 },
  { i: "deltaEscrow", x: 1, y: 3, w: 1, h: 1 },
  { i: "titleInsurance", x: 0, y: 7, w: 3, h: 1 },

];

export default function Home() {
  const navigate = useNavigate();

  const breakpoints = { lg: 520, sm: 0 };
  const cols = { lg: 3, sm: 1 };

  const layouts = {
    lg: layout,
    sm: layout.map(item => ({ ...item, x: 0, w: 1 })),
  };

  const handleClick = (url) => {
    if (url.startsWith("http")) {
      window.open(url, "_blank", "noopener");
    } else {
      navigate(url);
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className="home-container-agent">
      <div className="grid-wrapper">
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={150}
          isResizable={false}
          isDraggable={false}
        >
          {widgets.map((widget) => (
            <div
              key={widget.key}
              className="widget-card"
              onClick={() => handleClick(widget.url)}
            >
              <img src={widget.icon} alt={widget.title} className="widget-icon" />
            </div>
          ))}
        </ResponsiveGridLayout>
      </div>
    </div>
  );
}
